"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNaicsInput = void 0;
var throttle_1 = __importDefault(require("lodash/throttle"));
var react_1 = require("react");
var naics_1 = require("../types/naics");
var Action;
(function (Action) {
    Action[Action["FOUR_DIGITS_FETCHED"] = 0] = "FOUR_DIGITS_FETCHED";
    Action[Action["FOUR_DIGITS_SELECTED"] = 1] = "FOUR_DIGITS_SELECTED";
    Action[Action["QUERY_CLEARED"] = 2] = "QUERY_CLEARED";
    Action[Action["QUERY_ISSUED"] = 3] = "QUERY_ISSUED";
    Action[Action["REFINE_TOGGLED"] = 4] = "REFINE_TOGGLED";
    Action[Action["SIX_DIGITS_FETCHED"] = 5] = "SIX_DIGITS_FETCHED";
    Action[Action["SIX_DIGITS_SELECTED"] = 6] = "SIX_DIGITS_SELECTED";
    Action[Action["TWO_DIGITS_FETCHED"] = 7] = "TWO_DIGITS_FETCHED";
    Action[Action["TWO_DIGITS_SELECTED"] = 8] = "TWO_DIGITS_SELECTED";
})(Action || (Action = {}));
var initialState = {
    fourDigitsNaics: [],
    fourDigitsValue: '',
    isFourDigitsLoading: true,
    isRefinedSearch: false,
    isSixDigitsLoading: false,
    isTwoDigitsLoading: true,
    query: '',
    sixDigitsNaics: [],
    sixDigitsValue: '',
    twoDigitsNaics: [],
    twoDigitsValue: '',
};
function reducer(state, action) {
    switch (action.type) {
        case Action.TWO_DIGITS_FETCHED: {
            return __assign(__assign({}, state), { isTwoDigitsLoading: false, twoDigitsNaics: action.naics || [] });
        }
        case Action.FOUR_DIGITS_FETCHED: {
            return __assign(__assign({}, state), { isFourDigitsLoading: false, fourDigitsNaics: action.naics || [] });
        }
        case Action.SIX_DIGITS_FETCHED: {
            return __assign(__assign({}, state), { isSixDigitsLoading: false, sixDigitsNaics: action.naics || [] });
        }
        case Action.TWO_DIGITS_SELECTED: {
            return __assign(__assign({}, state), { fourDigitsValue: '', query: '', sixDigitsNaics: [], twoDigitsValue: action.value });
        }
        case Action.FOUR_DIGITS_SELECTED: {
            return __assign(__assign({}, state), { query: '', sixDigitsNaics: [], fourDigitsValue: action.value });
        }
        case Action.SIX_DIGITS_SELECTED: {
            return __assign(__assign({}, state), { sixDigitsValue: action.value });
        }
        case Action.QUERY_ISSUED: {
            return __assign(__assign({}, state), { query: action.query });
        }
        case Action.QUERY_CLEARED: {
            return __assign(__assign({}, state), { query: '' });
        }
        case Action.REFINE_TOGGLED: {
            return state.isRefinedSearch
                ? __assign(__assign({}, initialState), { fourDigitsNaics: state.fourDigitsNaics, isFourDigitsLoading: state.isFourDigitsLoading, isRefinedSearch: false, isTwoDigitsLoading: state.isTwoDigitsLoading, sixDigitsNaics: state.sixDigitsNaics, sixDigitsValue: state.sixDigitsValue, twoDigitsNaics: state.twoDigitsNaics }) : __assign(__assign({}, state), { isRefinedSearch: true });
        }
        default:
            throw new Error("Unknown action type ".concat(action.type));
    }
}
function useNaicsInput(_a) {
    var _this = this;
    var handleChange = _a.handleChange, handleSearch = _a.handleSearch, initialValue = _a.initialValue;
    var _b = (0, react_1.useReducer)(reducer, initialState), _c = _b[0], fourDigitsNaics = _c.fourDigitsNaics, fourDigitsValue = _c.fourDigitsValue, isFourDigitsLoading = _c.isFourDigitsLoading, isRefinedSearch = _c.isRefinedSearch, isSixDigitsLoading = _c.isSixDigitsLoading, isTwoDigitsLoading = _c.isTwoDigitsLoading, query = _c.query, sixDigitsNaics = _c.sixDigitsNaics, sixDigitsValue = _c.sixDigitsValue, twoDigitsNaics = _c.twoDigitsNaics, twoDigitsValue = _c.twoDigitsValue, dispatch = _b[1];
    // Load full list of two and four digits NAICS. These lists are small and should only be loaded once
    (0, react_1.useEffect)(function () {
        handleSearch({ mode: naics_1.NaicsSearchMode.TWO_DIGITS }).then(function (_a) {
            var naics = _a.naics;
            dispatch({ type: Action.TWO_DIGITS_FETCHED, naics: naics });
        });
        handleSearch({ mode: naics_1.NaicsSearchMode.FOUR_DIGITS }).then(function (_a) {
            var naics = _a.naics;
            dispatch({ type: Action.FOUR_DIGITS_FETCHED, naics: naics });
        });
    }, [handleSearch]);
    // Throttled six-digit request on input's value change
    var handleSixDigitFilterChange = (0, react_1.useMemo)(function () { return (0, throttle_1.default)(function (newQuery) { return dispatch({ type: Action.QUERY_ISSUED, query: newQuery }); }, 500); }, []);
    var fetchSixDigits = (0, react_1.useCallback)(function (query, digitsFilter) { return __awaiter(_this, void 0, void 0, function () {
        var naics;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, handleSearch({ mode: naics_1.NaicsSearchMode.SIX_DIGITS, query: query, digitsFilter: digitsFilter })];
                case 1:
                    naics = (_a.sent()).naics;
                    dispatch({ type: Action.SIX_DIGITS_FETCHED, naics: naics });
                    return [2 /*return*/];
            }
        });
    }); }, [handleSearch]);
    // Hydrate state according to initial value
    (0, react_1.useEffect)(function () {
        if (initialValue) {
            var value = String(initialValue);
            dispatch({ type: Action.SIX_DIGITS_SELECTED, value: value });
            fetchSixDigits(value);
        }
    }, [fetchSixDigits, initialValue]);
    // If there is a query and/or four/two digits filters, do the search according to these values
    (0, react_1.useEffect)(function () {
        if (query || fourDigitsValue || twoDigitsValue) {
            fetchSixDigits(query, fourDigitsValue || twoDigitsValue);
        }
    }, [fetchSixDigits, fourDigitsValue, query, twoDigitsValue]);
    var handleSelectSixDigits = (0, react_1.useCallback)(function (value) {
        dispatch({ type: Action.SIX_DIGITS_SELECTED, value: value });
        handleChange(value ? +value : null);
    }, [handleChange]);
    var handleSelectFilterFactory = (0, react_1.useCallback)(function (actionType) { return function (value) {
        if (!sixDigitsValue.startsWith(value)) {
            handleSelectSixDigits('');
        }
        dispatch({ type: actionType, value: value });
    }; }, [handleSelectSixDigits, sixDigitsValue]);
    var filteredFourDigitsNaics = (0, react_1.useMemo)(function () {
        return twoDigitsValue
            ? fourDigitsNaics.filter(function (naics) { return naics.id.toString().startsWith(twoDigitsValue); })
            : fourDigitsNaics;
    }, [fourDigitsNaics, twoDigitsValue]);
    return {
        fourDigitsNaics: filteredFourDigitsNaics,
        fourDigitsValue: fourDigitsValue,
        handleClearQuery: function () { return dispatch({ type: Action.QUERY_CLEARED }); },
        handleSelectFourDigits: handleSelectFilterFactory(Action.FOUR_DIGITS_SELECTED),
        handleSelectSixDigits: handleSelectSixDigits,
        handleSelectTwoDigits: handleSelectFilterFactory(Action.TWO_DIGITS_SELECTED),
        handleSixDigitFilterChange: handleSixDigitFilterChange,
        handleToggleRefine: function () { return dispatch({ type: Action.REFINE_TOGGLED }); },
        isFourDigitsLoading: isFourDigitsLoading,
        isRefinedSearch: isRefinedSearch,
        isSixDigitsLoading: isSixDigitsLoading,
        isTwoDigitsLoading: isTwoDigitsLoading,
        sixDigitsNaics: sixDigitsNaics,
        sixDigitsValue: sixDigitsValue,
        twoDigitsNaics: twoDigitsNaics,
        twoDigitsValue: twoDigitsValue,
    };
}
exports.useNaicsInput = useNaicsInput;
